export const getRealmRolesFromToken = (token?: string | null): string[] => {
  if (!token) return [];
  try {
    const [, payload] = token.split('.');
    const json = JSON.parse(atob((payload || '').replace(/-/g, '+').replace(/_/g, '/')));
    const realmRoles: string[] = json?.realm_access?.roles || [];
    const clientRoles: string[] = [];
    if (json?.resource_access) {
      for (const clientId of Object.keys(json.resource_access)) {
        const roles = json.resource_access[clientId]?.roles;
        if (Array.isArray(roles)) {
          clientRoles.push(...roles);
        }
      }
    }
    return [...new Set([...(Array.isArray(realmRoles) ? realmRoles : []), ...clientRoles])];
  } catch {
    return [];
  }
};

